import { jsx as _jsx } from "react/jsx-runtime";
import { CanvasModulateContext } from '../canvasModulate.js';
import { CanvasLighting2DContext, INERT_CANVAS_LIGHTING } from './lightPassContext.js';
import { NoShadowCasters } from './ShadowCasterStage.js';
export function World2DLightingBoundary({ canvasModulate, children }) {
    return (_jsx(CanvasLighting2DContext.Provider, { value: INERT_CANVAS_LIGHTING, children: _jsx(CanvasModulateContext.Provider, { value: canvasModulate, children: _jsx(NoShadowCasters, { children: children }) }) }));
}
//# sourceMappingURL=World2DLightingBoundary.js.map